module.exports = __webpack_public_path__ + "static/assets/fcfa8c48a15bdc2d95074081d8bcf843.svg";